<template>
  <a class="m-file-display" :href="url">
    <img :src="thumbnail" aria-hidden="true" />
    <span>{{ name }}</span>
  </a>
</template>

<script setup lang="ts">
defineProps<{
  url: string;
  thumbnail: string;
  name: string;
}>();
</script>

<style lang="scss" scoped>
.m-file-display {
  display: flex;

  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  /* identical to box height */

  letter-spacing: 0.01em;
  text-decoration-line: underline;
  text-underline-offset: 3px;

  color: #0099ff;

  img {
    flex: 1 1 auto;
    object-fit: contain;
    height: 100%;
    width: auto;

    border-radius: 4px;
  }
  span {
    flex: 1 1 auto;
    display: block;
    white-space: nowrap;

    align-self: center;
    margin-left: 16px;
  }
}
</style>
